import { DATE_TIME_FORMAT } from '@/constants'
import moment from 'moment-timezone'
import type { IPlacementSettings } from '@/stores/types'

export const getJamsBackendApi = () => {
  return import.meta.env.VITE_JAMS_BACKEND_URL
}

export const getCouponsApi = () => {
  return import.meta.env.VITE_COUPONS_API_URL
}

export const getLocalTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const getServerTimezone = (): string => {
  return import.meta.env.VITE_SERVER_TIMEZONE || 'America/New_York'
}

export const convertTimezone = (
  inputDateTime: string,
  inputTimezone: string,
  outputTimezone: string,
): string => {
  if (!inputDateTime) return ''

  const cleaned = inputDateTime
    .replace(' ', 'T') // "2025-05-24 4:47 AM" → "2025-05-24T4:47 AM"
    .replace(/:\d{2}$/, ':00') // if it ends with just hh:mm → hh:mm:00
    .replace(/Z$/, '') // remove trailing Z, to let moment.tz control tz

  // Handle cases where the input date might be different from the expected format
  const m = moment.tz(
    cleaned,
    [
      moment.ISO_8601,
      'YYYY-MM-DDTHH:mm:ss',
      'YYYY-MM-DDTHH:mm',
      'YYYY-MM-DD hh:mm A',
      'YYYY-MM-DDTHH:mm:ss.SSS',
    ],
    inputTimezone,
  )

  // Check if the moment object is valid
  if (!inputDateTime || typeof inputDateTime !== 'string') {
    console.warn('[convertTimezone] Invalid input date:', inputDateTime)
    return ''
  }

  // Converts the moment object to the desired output timezone and format
  return m.tz(outputTimezone).format(DATE_TIME_FORMAT)
}

export const convertLocalTimeToServerTime = (localTime: string): string => {
  return convertTimezone(localTime, getLocalTimezone(), getServerTimezone())
}

export const convertServerTimeToLocalTime = (serverTime: string): string => {
  return convertTimezone(serverTime, getServerTimezone(), getLocalTimezone())
}

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }
}

export function generateRandomId(length = 8): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  console.log(result)
  return result
}

export const isMobile = () =>
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

export const formatPlacementIdToFriendlyName = (id: string) => {
  return id.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
}

export const getDefaultPlacementSettings = (id: string): IPlacementSettings => {
  return {
    enabled: true,
    friendlyName: formatPlacementIdToFriendlyName(id),
    url: '',
    coupons: [],
  }
}
